import React, { useEffect, useState } from 'react';
import { Outlet, useParams, useNavigate, useLocation } from 'react-router-dom';
import { Steps } from 'primereact/steps';
import { MenuItem } from 'primereact/menuitem';

const STEP_ROUTES = [
  'data-acquisition',
  'data-review',
  'customer-identification',
  'reconciliation',
];

export const ClientLayout: React.FC = () => {
  const { clientId } = useParams<{ clientId: string }>();
  const navigate = useNavigate();
  const location = useLocation();

  // Determine active step based on current route
  const getActiveIndex = (): number => {
    const path = location.pathname;
    const index = STEP_ROUTES.findIndex((route) => path.includes(route));
    return index >= 0 ? index : 0;
  };

  const [activeIndex, setActiveIndex] = useState(getActiveIndex());

  useEffect(() => {
    setActiveIndex(getActiveIndex());
  }, [location.pathname]);

  const handleStepSelect = (index: number) => {
    setActiveIndex(index);
    navigate(`/clients/${clientId}/${STEP_ROUTES[index]}`);
  };

  const stepItems: MenuItem[] = [
    { label: 'Data Acquisition', command: () => handleStepSelect(0) },
    { label: 'Data Review', command: () => handleStepSelect(1) },
    { label: 'Customer Identification', command: () => handleStepSelect(2) },
    { label: 'Reconciliation', command: () => handleStepSelect(3) },
  ];

  return (
    <>
      <Steps
        model={stepItems}
        activeIndex={activeIndex}
        onSelect={(e) => handleStepSelect(e.index)}
        readOnly={false}
      />
      <div className="step-container">
        <Outlet />
      </div>
    </>
  );
};
